import React from 'react';

type TrainerHeaderProps = {
    title: string;
};

const TrainerHeader: React.FC<TrainerHeaderProps> = ({ title }) => {
    return (
        <div className="w-full p-4 flex items-center justify-end bg-white sticky top-0 z-30 shadow-sm">
        </div>
    );
};

export default TrainerHeader;